import { Pie } from 'react-chartjs-2';
import '../../../css/popup.css';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { NonSalgu } from '../../../images/icons/icons_component';

ChartJS.register(ArcElement, Tooltip, Legend);

// 파스텔톤 랜덤 색상 생성 함수
const pastelColors = [
    "rgb(230, 121, 143)",
    "rgb(246, 215, 106)",
    "rgb(153, 204, 102)",
    "rgb(102, 204, 204)",
    "rgb(187, 222, 251)",
    "rgb(101, 171, 235)",
    "rgb(54, 110, 183)",
    "rgb(143, 107, 229)"
];

const PieChart = ({ data }) => {
    const title = data.length > 0 ? data[0].CHART_TITLE : '차트 정보';

    const labels = data.map(item => item.CHART_CATEGORY);
    const values = data.map(item => item.CHART_VALUE);
    const backgroundColors = data.map((_, idx) => pastelColors[idx % pastelColors.length]);
    const total = values.reduce((sum, val) => sum + val, 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: title,
                type: 'doughnut',
                data: values,
                backgroundColor: backgroundColors,
                borderColor: '#ffffff',
                borderWidth: 1,
                hoverOffset: 1,
            },
        ],
    };

    const options = {
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.label || '';
                        const value = context.raw || 0;
                        const percent = ((value / total) * 100).toFixed(1);
                        return `${label}: ${percent}%`;
                    },
                },
            },
            legend: {
                display: false,
            },
        },
    };

    return (
        <>
            {data.length > 0 ?
                <>
                    <h4 className='text-center mb-5'>{title}</h4>
                    <div className='inner'>
                        <div className='legend'>
                            {labels.map((item, idx) =>
                                <div className='flex gap-1 text-xs'>
                                    <div className='legend_icon' style={{ backgroundColor: backgroundColors[idx] }} />
                                    <span className='font-bold'>{item}</span>
                                </div>
                            )}
                        </div>
                        <div className='chart'>
                            <Pie data={chartData} options={options} />
                        </div>
                    </div>
                </>
                :
                <>
                    <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>{title}</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '50px', gap: '10px' }}>
                        <NonSalgu /><div>해당하는 데이터가 없습니다.</div>
                    </div>
                </>
            }
        </>
    );
};

export default PieChart;
